import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { useLayout } from '../../contexts/layout-context';
// Keep the API service class imports specific, to prevent circular dependency issues
import { setupInterceptors } from '../api-config';

setupInterceptors();

/**
 * Provider that delivers:
 * - the initializes api services in the YwuApiProvider and
 * - the QueryClientProvider for using tanstack-queries.
 */
export const TanStackQueryProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { shadowRoot } = useLayout();
    const queryClient = useMemo(() => new QueryClient(), []);

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} shadowDOMTarget={shadowRoot} />
            {children}
        </QueryClientProvider>
    );
};
